import { createProviderToken } from '@core/common-legacy';

export interface AddEvaluationsDropdownModuleTranslations {
  interview: {
    evaluationForms: string;
    evaluationRequest: string;
    required: string;
    addNow: string;
    template: string;
    templateHidden: string;
    emptyTemplateTitle: string;
    emptyTemplateDescription: string;
    job: string;
    jobPlaceholder: string;
    templatePlaceholder: string;
    manageForms: string;
    cancel: string;
    requestNow: string;
    start: string;
    chooseForm: string;
    fillOutForm: string;
    scheduleDialog: {
      requestFrom: string;
      requestEvaluation: string;
      add: string;
      assignmentsTitle: string;
      assignmentsDesc: string;
    };
  };
}

export const {
  inject: injectAddEvaluationDropdownTranslations,
  provide: provideAddEvaluationDropdownTranslations,
} = createProviderToken<AddEvaluationsDropdownModuleTranslations>(
  'AddEvaluationsDropdownModuleTranslations',
)();

const keys = {
  evaluationForms: 'app.interview.evaluation_forms',
  evaluationRequest: 'app.interview.evaluation_request',
  required: 'app.interview.required',
  addNow: 'app.interview.add_now',
  template: 'app.interview.template',
  templateHidden: 'app.interview.template_hidden',
  emptyTemplateTitle: 'app.interview.empty_template_title',
  emptyTemplateDescription: 'app.interview.empty_template_description',
  job: 'app.interview.job',
  jobPlaceholder: 'app.interview.job_placeholder',
  templatePlaceholder: 'app.interview.template_placeholder',
  manageForms: 'app.interview.manage_forms',
  cancel: 'app.interview.cancel',
  requestNow: 'app.interview.request_now',
  start: 'app.interview.start',
  fillOutForm: 'app.interview.fill_out_form',
  chooseForm: 'app.interview.choose_form',
  scheduleDialog: {
    requestFrom: 'app.interview.schedule_dialog.request_from',
    requestEvaluation: 'app.interview.schedule_dialog.request_evaluation',
    assignmentsTitle: 'app.interview.schedule_dialog.assignments_title',
    assignmentsDesc: 'app.interview.schedule_dialog.assignments_desc',
    add: 'app.interview.schedule_dialog.add',
  },
};

export const PROVIDE_ADD_EVALUATION_DROPDOWN_TRANSLATIONS_ADD =
  provideAddEvaluationDropdownTranslations({
    useValue: {
      interview: keys,
    },
  });

export const PROVIDE_ADD_EVALUATION_DROPDOWN_TRANSLATIONS_SAVE =
  provideAddEvaluationDropdownTranslations({
    useValue: {
      interview: {
        ...keys,
        scheduleDialog: {
          ...keys.scheduleDialog,
          add: 'app.common.save',
        },
      },
    },
  });
